const EMOJIS = [
  "😀", "😂", "🤣", "😊", "😍", "😘", "😎", "🤩", "🥳", "😜",
  "🤔", "😏", "😴", "😭", "😅", "😆", "🙃", "😇", "🥰", "😋",
  "👍", "👎", "👏", "🙌", "🤝", "🙏", "💪", "✌️", "👌", "🤟",
  "❤️", "🔥", "✨", "🎉", "💯", "⭐", "💥", "🌈", "☀️", "⚡",
  "🚀", "🎯", "💡", "📌", "✅", "❌", "⏰", "🎁", "💬", "👀",
];

export default function EmojiPicker({ onSelect }) {
  return (
    <div className="z-50 border border-slate-200 dark:border-slate-800 rounded-2xl overflow-hidden shadow-2xl bg-white dark:bg-slate-900 p-3 w-72">
      <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 mb-2 px-1">Emoji</p>
      <div className="grid grid-cols-8 gap-1 max-h-52 overflow-y-auto">
        {EMOJIS.map((e, i) => (
          <button
            key={i}
            type="button"
            data-testid="emoji-option"
            onClick={() => onSelect(e)}
            className="text-xl p-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
